// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gcud","label":"styles_label__1rDXf"};